export default __webpack_public_path__ + "static/media/dashboard_icon_white.b743fd18.svg";